import { IOrderFlexibleColumns } from '../../../../components/reusable/Table/types';
import { TFunction } from 'i18next';

export enum NOTIFICATION_TEMPLATE_COLUMN_IDS {
  CODE = 'code',
  CATEGORY = 'category',
  PREFERENCE_GROUP = 'preferenceGroup',
  DISPLAY_DOMAIN = 'displayDomain',
  ACTIVE = 'active',
  UPDATED_AT = 'updatedAt',
  ACTIONS = 'ACTIONS',
}

const defaultOrderBy = NOTIFICATION_TEMPLATE_COLUMN_IDS.CODE;

function columns(
  t: TFunction,
  includeActions: boolean,
): IOrderFlexibleColumns[] {
  const main: IOrderFlexibleColumns[] = [
    {
      id: NOTIFICATION_TEMPLATE_COLUMN_IDS.CODE,
      label: t('adminDashboard.notifications.templates.code'),
      key: NOTIFICATION_TEMPLATE_COLUMN_IDS.CODE,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: NOTIFICATION_TEMPLATE_COLUMN_IDS.CODE,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: NOTIFICATION_TEMPLATE_COLUMN_IDS.CATEGORY,
      label: t('adminDashboard.notifications.templates.category'),
      key: NOTIFICATION_TEMPLATE_COLUMN_IDS.CATEGORY,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: NOTIFICATION_TEMPLATE_COLUMN_IDS.CATEGORY,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: NOTIFICATION_TEMPLATE_COLUMN_IDS.PREFERENCE_GROUP,
      label: t('adminDashboard.notifications.templates.preferenceGroup'),
      key: NOTIFICATION_TEMPLATE_COLUMN_IDS.PREFERENCE_GROUP,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: NOTIFICATION_TEMPLATE_COLUMN_IDS.PREFERENCE_GROUP,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: NOTIFICATION_TEMPLATE_COLUMN_IDS.DISPLAY_DOMAIN,
      label: t('adminDashboard.notifications.templates.displayDomain'),
      key: NOTIFICATION_TEMPLATE_COLUMN_IDS.DISPLAY_DOMAIN,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: NOTIFICATION_TEMPLATE_COLUMN_IDS.DISPLAY_DOMAIN,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: NOTIFICATION_TEMPLATE_COLUMN_IDS.ACTIVE,
      label: t('adminDashboard.notifications.templates.active'),
      key: NOTIFICATION_TEMPLATE_COLUMN_IDS.ACTIVE,
      type: 'boolean',
      sortable: true,
      draggable: false,
      sortingKey: NOTIFICATION_TEMPLATE_COLUMN_IDS.ACTIVE,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: NOTIFICATION_TEMPLATE_COLUMN_IDS.UPDATED_AT,
      label: t('adminDashboard.notifications.templates.updatedAt'),
      key: NOTIFICATION_TEMPLATE_COLUMN_IDS.UPDATED_AT,
      type: 'date',
      sortable: true,
      draggable: false,
      sortingKey: NOTIFICATION_TEMPLATE_COLUMN_IDS.UPDATED_AT,
      align: 'left',
      hided: false,
      canHide: false,
    },
  ];
  if (includeActions) {
    main.push({
      id: NOTIFICATION_TEMPLATE_COLUMN_IDS.ACTIONS,
      key: NOTIFICATION_TEMPLATE_COLUMN_IDS.ACTIONS,
      label: '',
      type: 'string',
      sortable: false,
      sortingKey: NOTIFICATION_TEMPLATE_COLUMN_IDS.ACTIONS,
      align: 'right',
      hided: false,
      isFixed: true,
      canHide: false,
    });
  }
  return main;
}

export default function getNotificationTemplatesTableColumns(
  t: TFunction,
  includeActions = true,
): IOrderFlexibleColumns[] {
  return columns(t, includeActions);
}

const hidedColumns: string[] = [];

export const getNotificationTemplatesDefaultSettings = (
  t: TFunction,
  includeActions = true,
) => ({
  columnsOrderIds: columns(t, includeActions)
    .filter((c) => !c.hided && !c.isFixed)
    .map((c) => c.id),
  orderBy: defaultOrderBy,
  order: 'asc',
  hidedColumns,
});
